
define('text!modules/map/map_template.html',[],function () { return '<div id="map" class="map-view js-map">\r\n  <div class="js-map-players"></div>\r\n  <div class="js-map-overlay"></div>\r\n</div>\r\n\r\n';});

